import { useState } from "react";
import { useNavigate } from "react-router-dom";
import SectionHeader from "@/components/feature/SectionHeader";

const faqs = [
  {
    q: "小虎看番的片单是怎么整理出来的？",
    a: "小虎看番综合了评分热度、观众讨论与弹幕口碑，加上多年补番经验，把值得看的好番按「高分、冷门、完结、熬夜」四大主题分类整理，方便你快速找到合口味的片单。",
  },
  {
    q: "片单里的评分是哪里来的？",
    a: "评分综合了主流平台的观众评分与口碑反馈，并人工标注「封神、神作、名场面」等标签。评分仅作参考，适合自己的才是最好的番。",
  },
  {
    q: "冷门佳作和口碑番有什么区别？",
    a: "口碑番是热度高、讨论多的作品；冷门佳作则评分同样出色、但被多数人忽略的宝藏。小虎两边都在挖，热门不错过，宝藏也不放过。",
  },
  {
    q: "番剧片单会定期更新吗？",
    a: "会的。高分番排行榜、冷门佳作和完结番合集每周五更新，熬夜补番清单也会随新番动态调整，订阅「小虎片单」即可每周直达最新内容。",
  },
  {
    q: "如何向小虎推荐一部好番？",
    a: "欢迎通过页脚的邮箱告诉我们你的心头好，经小虎和观众确认口碑后，就有机会被收录进对应片单，分享给更多正在剧荒的朋友。",
  },
];

function FaqItem({ item, isOpen, onToggle }: { item: (typeof faqs)[number]; isOpen: boolean; onToggle: () => void }) {
  return (
    <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
      <button
        type="button"
        onClick={onToggle}
        className="flex w-full items-center justify-between gap-3 px-4 py-4 text-left md:px-5"
        aria-expanded={isOpen}
      >
        <h3 className="text-sm font-semibold text-foreground-900 md:text-base">{item.q}</h3>
        <span
          className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-secondary-700 transition-transform duration-300 ${
            isOpen ? "rotate-180" : ""
          }`}
        >
          <i className="ri-arrow-down-s-line text-lg" aria-hidden="true"></i>
        </span>
      </button>
      {isOpen && (
        <div className="border-t border-background-100 px-4 py-4 md:px-5">
          <p className="text-sm leading-relaxed text-foreground-700">{item.a}</p>
        </div>
      )}
    </div>
  );
}

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);
  const navigate = useNavigate();

  return (
    <section className="bg-background-100">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-8 md:grid-cols-2 md:gap-12">
          <div>
            <SectionHeader
              eyebrow="口碑与帮助"
              title="关于小虎，你可能会好奇"
              desc="这里整理了大家最常问的问题。想了解更多品牌故事，欢迎逛逛「关于我们」。"
            />
            <div className="rounded-lg border border-primary-200 bg-primary-50 p-5 md:p-6">
              <div className="flex items-center gap-2 text-primary-700">
                <i className="ri-double-quotes-l text-2xl" aria-hidden="true"></i>
                <span className="font-display text-lg">小虎的一句话</span>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-foreground-800">
                补番不难，难的是不知道看哪部。小虎的存在，就是帮你把「今天看什么」这个每天纠结的难题，
                变成「点开就有好片单」的安心感。
              </p>
              <button
                type="button"
                onClick={() => navigate("/about")}
                className="mt-4 inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                了解小虎看番
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </button>
            </div>
          </div>

          <div className="space-y-3" id="faq">
            {faqs.map((item, i) => (
              <FaqItem
                key={item.q}
                item={item}
                isOpen={openIndex === i}
                onToggle={() => setOpenIndex(openIndex === i ? -1 : i)}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}